export default "__VITE_ASSET__2RnrOxnF__"